import React from "react"
import { css } from "react-emotion"

import { Button, ButtonModal } from "ui"
import AttributesForm from "features/records/components/AttributesForm"
import WithBlocks from "data/wrappers/WithBlocks"

const NewBlockButton = props => (
    <WithBlocks>
        {({ createBlock }) => (
            <ButtonModal
                button={({ open }) => (
                    <Button
                        icon="plus"
                        color="clear"
                        onClick={open}
                    >
                        New Block
                    </Button>
                )}
                header={() => `New Block`}
                footerClassName={css`
                    justify-content: flex-end;
                `}
                footer={({ close, state }) => [
                    <Button
                        key="create"
                        sideMargin="xsmall"
                        color="success"
                        onClick={() => {
                            createBlock(state)
                            close()
                        }}
                    >
                        Create
                    </Button>,
                    <Button key="cancel" sideMargin="xsmall" onClick={close}>
                        Cancel
                    </Button>,
                ]}
            >
                {({ setState }) => (
                    <AttributesForm
                        onChange={setState}
                        fields={[{ type: "text", label: "Name", api_name: "name" }]}
                    />
                )}
            </ButtonModal>
        )}
    </WithBlocks>
)
export default NewBlockButton



// WEBPACK FOOTER //
// ./src/features/studio/components/NewBlockButton.js